import React from 'react';
import { Formik } from 'formik';
import { PopupOrPanel } from '../../components/popupsAndPanels/PopupAndPanels';
import { TableFilters } from './tableFilters';

type Props = {
  listUrl: string;
  loadInfoTableList: (listUrl: string, paramsArr?: any) => void;
  panelOpen: boolean;
  togglePanelOpen: React.Dispatch<React.SetStateAction<boolean>>;
  listData: any;
};

export const ListTableFilter: React.FC<Props> = ({
  listUrl,
  loadInfoTableList,
  panelOpen,
  togglePanelOpen,
  listData
}) => {

  const handleSubmitForm = async (values: any) => {

    let filterValueList: any = [];
    let fieldsFiltered: number = 0;
    let endpointString: string = "";
  
    //input fields
    for (const property in values) {
      if(property.indexOf("_dropdown") === -1){
        filterValueList.push({ "field": property, "value": values[property] });
        ++fieldsFiltered;
      }
    }
  
    //dropdown fields
    if(fieldsFiltered > 0){
      for (const property in values) {
        
        if(property.indexOf("_dropdown") !== -1){
  
          //check if field already exists in array
          for(let i = 0; i < filterValueList.length; i++){
            if(filterValueList[i].field === property.replace('_dropdown','')){
              filterValueList[i].type = values[property].value.toUpperCase();
            }
          }
  
        }
      }
    }

    //set up string for endpoint
    if(filterValueList.length)  {
      filterValueList.map((item: any, index: number) => {
        if(index === 0){
          endpointString += item.field + " " + item.type + " (" + item.value + ")";
        } else {
          endpointString += " | " + item.field + " " + item.type + " (" + item.value + ")";
        }
      });

      loadInfoTableList(listUrl, [{ param: "bClearFilters", value: "false" }, { param: "filters", value: endpointString }]);
    } else {
      loadInfoTableList(listUrl, [{ param: "bClearFilters", value: "true" }]);
    }
  };  

  return (
    <Formik
      initialValues={{}}
      onSubmit={handleSubmitForm}
    >   
      {({ submitForm }) => (    
        <PopupOrPanel
          isPopup={false}
          isOpen={panelOpen}
          hdrTitle={"Filters"}
          position="right"
          primaryBtnTxt="Submit"
          secondaryBtnTxt="Cancel"
          givenClass="ListTableFilters"
          handleClose={() => togglePanelOpen(false)}
          handlePrimaryBtn={submitForm}
          handleSecondaryBtn={() => togglePanelOpen(false)}
          width={560}
        >
          <TableFilters listData={listData} />
        </PopupOrPanel>
      )}
    </Formik>        
  );
};    